export const emptyImage = `/images/empty.jpg`;

export const permission = {};

export const productType = {
    Subscription: 1,
    Certificate: 2,
    Booking: 3
};

export const qtyClients = [1,2,3,4,5,6,7,8,9,10];

// Позиции корзины компании для учёта занятости объектов при выборе времени
export const cartToReserved = (items, companyId) =>
    (items || [])
        .filter((i) => i.companyId === companyId && i.sale?.roomId)
        .map((i) => ({ productId: i.sale.productId, roomId: i.sale.roomId, date: i.sale.date, startMin: i.sale.startMin, qtyClients: i.sale.qtyClients }));

export const companyAuthMode = {
    PayTime: 0,
    BeforeBuy: 1,
    NoAuth: 2
};

export const paymentSystem = {
    Sbrf: 1,
    Raif: 2,
    Credit: 3,
    TinkoffCard: 4,
    CloudPayments: 5,
    SberPay: 6,
    PayKeeper: 7,
    Vtb: 8,
    YooKassa: 9,
    Gpb: 10,
};

export function hasPermission(permissions, permission) {
    if (!permissions) return false;

    let value = permissions[permission - 1];
    return value === 1;
}

export const getPermissionLabel = (code) => {
    switch (code) {
        default:
            return '';
    }
};

//** Проверка есть-ли оплата по карте для компании */
export const getHasCompanyCard = company => company.paySbrf || company.payVtb || company.payTinkoffCard || company.payCloudPayments || company.payPayKeeper || company.payYooKassa || company.payGpb;

//** Получить тип оплаты по карте для компании */
export const getCompanyCardPaymentSystem = company => {
    if (company.paySbrf) return paymentSystem.Sbrf;
    if (company.payVtb) return paymentSystem.Vtb;
    if (company.payTinkoffCard) return paymentSystem.TinkoffCard;
    if (company.payCloudPayments) return paymentSystem.CloudPayments;    
    if (company.payPayKeeper) return paymentSystem.PayKeeper;
    if (company.payYooKassa) return paymentSystem.YooKassa;
    if (company.payGpb) return paymentSystem.Gpb;
    return null;
}

//** Если autopay == false то проверяет есть-ли оплата по карте для компании, иначе проверяет что оплата по карте поддерживает автоплатеж */
export const getCompanyCardAutopay = (company, autopay) => {
    if (!autopay) return getHasCompanyCard(company);
    const system = getCompanyCardPaymentSystem(company);
    return system === paymentSystem.TinkoffCard || system === paymentSystem.CloudPayments || system === paymentSystem.Gpb;
}